export default {
  needconfirm: 'Butuh Konfirmasi',
  inprogress: 'Dalam Proses',
  done: 'Selesai',
  complete_full: 'Diterima Utuh',
  complete_half: 'Diterima Tidak Utuh',
  complete_reject: 'Ditolak',
  waiting: 'Menunggu Konfirmasi',
  pickup: 'Penjemputan',
  deliver: 'Pengiriman',
  notifTitle: 'Pesanan Anda Selesai',
  notifMessage: 'Berikan rating pada pengiriman barang Anda',
  status: 'Status',
  pickupDate: 'Tanggal Pengambilan',
  vehicleType: 'Tipe Kendaraan',
  vehicleNo: 'No Kendaraan',
  driverName: 'Nama Sopir',
  driverPhoneNo: 'Kontak Sopir',
  addInfo: 'Informasi Tambahan',
  originLoc: 'Lokasi Asal',
  senderName: 'Nama Pengirim',
  phoneNumber: 'No. Telpon',
  destinationLoc: 'Lokasi Tujuan',
  recipientName: 'Nama Penerima',
  category: 'Kategori Barang',
  subCategory: 'Sub Kategori Barang',
  deliveryNote: 'Catatan Pengiriman',
  cancelReason: 'Alasan Pembatalan',
  successCreate: 'Pesanan Berhasil Dibuat',
  cancelQuestion: 'Apa anda yakin ingin membatalkan pesanan?',
  cancelPlease: 'Silahkan pilih alasan pembatalan anda',
  cancelSubmit: 'Ya, Batalkan',
  back: 'Kembali',
  other: 'Lainnya',
  otherReason: 'Isi alasan lainnya',
  cancelSuccess: 'Pesanan Berhasil Dibatalkan',
  shipperConfirmSucess: 'Barang Berhasil Diterima Digudang',
  ratingMessage: 'Berikan rating pada pengiriman barang Anda.',
  noRating: 'Rating belum ada',
  ratingSuccess: 'Rating Berhasil diberikan',
  note: 'Catatan Pengembalian',
  pickupNote: 'Catatan Pengiriman'
}
